import { useState, useEffect } from "react";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import { messaging } from "./firebaseConfig";

function Notify() {
  const [token, setToken] = useState("");

  // ✅ Foreground notification using native Notification API
  useEffect(() => {
    const unsubscribe = onMessage(messaging, (payload) => {
      console.log("📩 Foreground message received:", payload);
      const { title, body } = payload.notification || {};

      if (Notification.permission === "granted") {
        new Notification(title, {
          body,
          // optional icon
        });
      }
    });

    return () => unsubscribe();
  }, []);

  // ✅ Token request + backend notification trigger
  async function handleTestNotify() {
    try {
      const permission = await Notification.requestPermission();
      if (permission !== "granted") {
        alert("Notifications are denied.");
        return;
      }

      const fetchedToken = await getToken(messaging, {
        vapidKey: process.env.REACT_APP_VAPID_KEY,
      });

      console.log("✅ FCM token:", fetchedToken);
      setToken(fetchedToken);

      const res = await fetch(
        "https://cloud.hxabyte.com/send-test-notification",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ token: fetchedToken }),
        }
      );

      const data = await res.json();
      console.log("✅ Notification sent:", data);
    } catch (err) {
      console.error("❌ Failed to send notification", err);
    }
  }

  return (
    <div className="notify-container">
      <p style={{ wordBreak: "break-word", maxWidth: "100%" }}>{token}</p>
      <h2>
        <button onClick={handleTestNotify}>Test Notify</button>
      </h2>
    </div>
  );
}

export default Notify;
